/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/chat/bot' }">chatBOT</el-breadcrumb-item>
      <el-breadcrumb-item>chatBOT{{title}}</el-breadcrumb-item>
    </el-breadcrumb>

    <!--新增-->
      <el-row>
        <el-col :span="12">
          <el-form label-width="140px" :model="editForm" :rules="rules" ref="editForm" style="margin-top: 50px;">
                <el-form-item label="chatBOT名称" prop="name">
                  <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入,如'小冰'"></el-input>
                </el-form-item>
              <el-row>
                <el-col :span="12">
                    <el-form-item label="chatBOTicon" prop="icon">
                      <el-upload
                        class="avatar-uploader"
                        action=""
                        :show-file-list="false"
                        :before-upload="beforeUploadFile"
                        :http-request="customUpload"
                        :limit="1"
                        :on-exceed="handleExceed8"
                        :on-remove="handleRemove8"
                        accept="image/jpeg,image/png"
                      >
                        <img v-if="editForm.icon" :src="editForm.icon" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon" v-loading.fullscreen.lock="save_loading"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="chatBOT头像logo" prop="logo">
                      <el-upload
                      class="avatar-uploader"
                        action=""
                        :show-file-list="false"
                        :before-upload="beforeUploadFile"
                        :http-request="customUploads"
                        :limit="1"
                        :on-exceed="handleExceed8" :on-remove="handleRemove8"
                        accept="image/jpeg,image/png"
                        >
                        <img v-if="editForm.logo" :src="editForm.logo" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                  </el-form-item>
                </el-col>
             </el-row>
                <el-form-item label="主题色" prop="theme_color">
                  <el-color-picker v-model="editForm.theme_color"></el-color-picker>
                </el-form-item>

                <el-form-item label="欢迎词" prop="content">
                  <el-input size="small" type="textarea" :rows="2" v-model="editForm.welcome_speech" auto-complete="off" placeholder="请输入欢迎词"></el-input>
                </el-form-item>

                <div class="recommend-container">
                   <el-form-item label="推荐问题" prop="is_network">
                    <div class="tags-container">
                  <el-tag
                    v-for="(question, index) in recommendQuestions"
                    :key="index"
                    closable
                    @close="deleteQuestion(index)"
                    class="question-tag"
                  >
                    {{ question }}
                  </el-tag>
                </div>
                  <!-- 输入新增区域 -->
                <div class="input-container">
                  <el-input
                    v-model="inputQuestion"
                    placeholder="请输入"
                    class="question-input"
                    @keyup.enter.native="addQuestion"
                  ></el-input>
                  <el-button
                    type="primary"
                    @click="addQuestion"
                    class="add-btn"
                  >新增</el-button>
                </div></el-form-item>


              </div>

                <!-- <el-form-item label="知识库选择" prop="k_id" width="250">
                  <el-select size="small" v-model="editForm.k_id" placeholder="请选择" class="userRole">
                    <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="是否嵌入chatWEB" prop="is_network">
                  <el-radio v-model="editForm.is_chatweb_embed" label="0">否</el-radio>
                  <el-radio v-model="editForm.is_chatweb_embed" label="1">嵌入<el-input style="margin-left: 20px;" size="small" v-model="editForm.chatweb_no" auto-complete="off" placeholder="请输入chatWEB编号"></el-input> </el-radio>
                </el-form-item>
                <el-form-item label="人工客服引导" prop="is_upload">
                  <el-radio v-model="editForm.customer_guidance" label="off">否</el-radio>
                  <el-radio v-model="editForm.customer_guidance" label="on">按钮引导</el-radio>
                  <!-- <el-radio v-model="editForm.customer_guidance" label="2">自动引导</el-radio> -->
                </el-form-item>
                <div class="tips">人工客服引导可已通过按钮或自动引导方式出现如下引导文案。</div>
                <div class="tips">自动引导即在通过调用本地知识库不能回答用户问题时才出现。</div>
                <div class="tips">注意：如例子所示，'< br />'作为换行符号</div>
                <el-form-item label="" prop="customer_guidance_text" style="margin-top: 20px;">
                  <el-input size="small" type="textarea" :rows="2" v-model="editForm.customer_guidance_text" auto-complete="off" placeholder=""></el-input>
                </el-form-item>

                <el-form-item label="知识库选择" prop="k_id" width="250">
                <el-select size="small" v-model="editForm.knowledge[0].id" placeholder="请选择" class="userRole">
                  <el-option v-for="type in payTypes" :label="type.name" :value="type.id" :key="type.id"></el-option>
                </el-select>
              </el-form-item>
          </el-form>
        <div  class="dialog-footer" style="margin-left: 100px;">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
        </div>
        </el-col>
        <el-col :span="12">
          <!-- <ChatWidget :config="config"></ChatWidget> -->
          <div class="chat_sz">
            <div class="chatsz_window">
              <div class="chatsz_header">
                <div class="chatsz_avatar">
                <img :src="editForm.icon" class="avatarimg" alt="" v-if="editForm.icon">
                <img src="../../assets/img/avatar.png" class="avatarimg" alt="" v-else>
                {{ editForm.name }}
                </div>
                <div class="sz_close" :style="{'--chat-bubble-color': hexToRgb(editForm.theme_color)}">
                </div>
              </div>
              <div class="chatsz_messages" ref="messageContainer">

                <div class="chatsz_logo">
                <img :src="editForm.logo" class="sz_logo" alt="" v-if="editForm.logo">
                <img src="../../assets/img/avatar.png" class="sz_logo" alt="" v-else>
              </div>

              <div class="chatsz_welcome" :style="{'--chat-bubble-color': hexToRgb(editForm.theme_color)}">
                <div class="chatsz_welcome_text" :style="{'--chat-bubble-color': hexToRgb(editForm.theme_color)}">
                  {{ editForm.welcome_speech }}
                </div>
              </div>
            <!-- 常见问题  列表 -->
            <div class="chatsz_actions" v-if="recommendQuestions">
                <div :style="{'--chat-bubble-color': hexToRgb(editForm.theme_color)}"
                    v-for="(question, index) in recommendQuestions"
                    :key="index"
                    closable
                    @click="goQuestion(question)"
                    class="chatsz_questions"
                  >
                    {{ question }}
                  </div>
              </div>


                <div
                  v-for="(msg, index) in messages"
                  :key="index"
                  :class="['chatsz_message', msg.sender]"
                  :style="{'--chat-bubble-color': hexToRgb(editForm.theme_color)}"
                >
                <img :src="editForm.icon" class="avatarimg" alt="" v-if="editForm.icon&&msg.sender=='szbot'">
                <img src="../../assets/img/avatar.png" class="avatarimg" alt="" v-if="!config.avatar&&msg.sender=='szbot'">
                  <div class="sz_bubble">{{ msg.text }}</div>
                </div>
              </div>

              <!-- 人工客服 -->
              <div class="chatsz_contact" v-html="editForm.customer_guidance_text" :style="{'--chat-bubble-color': hexToRgb(editForm.theme_color)}">
              </div>

              <div class="input-area">
                <div class="custom-input">
                  <input
                    v-model="inputMsg"
                    placeholder="请输入你的问题"
                    @keyup.enter="sendszMessage"
                    class="message-input"
                  />
                  <div class="sz_svg_send"  v-if="inputMsg" @click="sendszMessage" :style="{'--chat-bubble-color': hexToRgb(editForm.theme_color)}"></div>
                  <div class="sz_svg"  v-else></div>
                </div>
                <div class="sz_rgkf" @click="config.is_online=1">
                  <div class="sz_svg_rgkf"  v-if="config.is_online" :style="{'--chat-bubble-color': hexToRgb(editForm.theme_color)}"></div>
                </div>
              </div>
            </div>
            </div>
        </el-col>
    </el-row>



  </div>
</template>

<script>
import { chatBOTSave, chatBOTGet, chatBOTCreate,knowledgeList,ossUpload} from '../../api/userMG'
import ChatWidget from '../../components/ChatWidget'
export default {
  data() {
    return {
      imageUrl:'',
       recommendQuestions: ["实名认证多久通过？", "SDK使用手册"], // 初始示例问题
      inputQuestion: "",
      inputMessage: '',
      circleUrl:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      messages: [],
      save_loading: false, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      payType: [
        { key: '全部', value: 0 },
        { key: 'chatWEB', value: 'chatWEB' },
        { key: 'chatBOT', value: 'chatBOT' },
        { key: 'chatAPl', value: 'chatAPl' },
      ],
      payTypes:[],
      inputMsg:'',
      title: '新增',
      editForm: {
        // Id: '',
        name: '小冰',
        icon: '',
        logo:'',
        theme_color:'#409EFF',
        is_chatweb_embed:'0',
        chatweb_no:'',
        "knowledge": [
          {
            "id": ''
          }
        ],
        customer_guidance:'off',
        welcome_speech:'你好，我是小冰，请问有什么可以帮助你的吗？',
        customer_guidance_text:'联系时间：9:00-15:00 周一至周五</br>联系电话：1888888888 </br>联系微信：1234567890',
      },
      config:{
      title: "智能客服",
      theme: "#F68020",
      welcome: "您好，我是智能助手，有什么可以帮您解答的问题？",
      avatar: "https://gips3.baidu.com/it/u=1907453080,4211057612&fm=3028&app=3028&f=JPEG&fmt=auto&q=100&size=f1000_1000",
      logo:'',
      position: "right",
      recommendQuestions: ["实名认证多久通过？", "SDK使用手册"],
      isNetwork: false,
      isUpload: false,
      is_show:false,
      is_online:2,
      is_show_online:false,
      contact_content: "联系时间：9:00-15:00 周一至周五</br>联系电话：1888888888 </br>联系微信：1234567890",
    },
      // rules表单验证
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        platform: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    ChatWidget
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    //获取路由参数
   // this.$router.push({ path: '/chat/bot_add', query: { id: row.deptId } })
    this.id = this.$route.query.id;
    console.log(this.id)
    if(this.id){
      this.title = '编辑';
      this.getdata(this.id)
    }
    this.kdetail();
    // 添加用户消息
    this.messages.push({
      sender: 'sz_user',
      text: '介绍一下你们公司'
      })
      setTimeout(() => {
        this.messages.push({
          sender: 'szbot',
          text: '为你找到以下内容：'
        })
      }, 1000)

      this.inputMessage = ''
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleExceed8(files, fileList8) {
				this.save_loading = false;
			  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList8.length} 个文件`);
			 },
    handleRemove8(file, fileList) {
      console.log(file, 'fileList111111111111');
      this.save_loading = false;
      // 只移除当前文件，保留其他文件
      const index = this.fileList.findIndex(item => item.name === file.name);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
      this.save_loading = true;
      //return;
    },
    beforeUploadFile(file) {
					    const isImage = file.type.startsWith('image/');
					      if (!isImage) {
							  this.save_loading = false;
					        this.$message.error('只能上传图片文件!');
					        return false;
					      }

					        const isLt2M = file.size / 1024 / 1024 < 50;
					        if (!isLt2M) {
					          this.$message.error('上传的文件大小不能超过 50MB!');
					          return false;
					        }

					        return true;
			},
      customUpload({ file, onSuccess, onError }) {
                this.save_loading = true;
                console.log(file,1111111111111111111111111);
                console.log(file.type,1111111111111111111111111);
                const datas = {};
                if(file.type=='image/png'){
                  datas.file_ext = '.png';
                }else{
                  datas.file_ext= '.jpg';
                }
                console.log(datas,1111111111111111111111111);
              //  const formData = new FormData();
					      // formData.append('file', file);
                ossUpload(datas)
                .then(res => {
                  console.log(res,'获取oss上传地址和配置')
                  if (res.message == "success") {
                    console.log(res.data,'res.data.key')
                      // 创建FormData对象用于OSS上传
                      const ossFormData = new FormData();
                      // 添加OSS上传所需的参数，确保参数名称正确
                      ossFormData.append("key", res.data.key);
                      // 确保policy是有效的JSON字符串
                      ossFormData.append("policy", res.data.policy);
                      // 确保参数名称与OSS要求一致
                      ossFormData.append("OSSAccessKeyId", res.data.ossAccessKeyId);
                      ossFormData.append("success_action_status", "200"); // 固定值
                      ossFormData.append("signature", res.data.signature);
                      ossFormData.append("x-oss-security-token", res.data.securityToken);
                      // 文件必须放在最后
                      ossFormData.append("file", file);
                      this.save_loading = true;
                      const xhr = new XMLHttpRequest();
                       xhr.open('POST', res.data.host, true);
                    //  xhr.open('POST', 'http://47.109.99.14:8875/v1/uploadFile', true);
                      // 不设置Content-Type，让浏览器自动设置multipart/form-data和boundary
                      xhr.onload = () => {
                        // console.log(xhr.response,22222222222222222222);
                        if (xhr.status >= 200 && xhr.status < 300) {
                          // 上传成功，设置图片URL
                          const cdnUrl = `https://${res.data.cdnDomain}/${res.data.key}`;
                          //  console.log('CDN URL:', cdnUrl);
                         // const response = JSON.parse(xhr.response);
                          //const cdnUrl = response.data.url;
                          // console.log('上传成功，文件URL:', cdnUrl);
                          this.editForm.icon = cdnUrl;
                          this.save_loading = false;
                          this.$message.success('上传成功');
                        } else {
                          this.save_loading = false;
                          this.$message.error(`上传失败: ${xhr.responseText}`);
                        }
                      };
                      xhr.onerror = (e) => {
                        console.error('上传错误:', e);
                        this.save_loading = false;
                        this.$message.error('上传失败，网络错误');
                      };
                      xhr.send(ossFormData);
                  } else {
                     this.save_loading = false;
                      this.$message({
                        type: 'info',
                        message: res.detail
                      })
                  }
                })
                .catch(err => {
                  this.save_loading = false
                  this.$message.error('操作失败，请稍后再试！')
                })

			},

      customUploads({ file, onSuccess, onError }) {
                this.save_loading = true;
                console.log(file,1111111111111111111111111);
                console.log(file.type,1111111111111111111111111);
                const datas = {};
                if(file.type=='image/png'){
                  datas.file_ext = '.png';
                }else{
                  datas.file_ext= '.jpg';
                }
                console.log(datas,1111111111111111111111111);
              //  const formData = new FormData();
					      // formData.append('file', file);
                ossUpload(datas)
                .then(res => {
                  console.log(res,'获取oss上传地址和配置')
                  if (res.message == "success") {
                    console.log(res.data,'res.data.key')
                      // 创建FormData对象用于OSS上传
                      const ossFormData = new FormData();
                      // 添加OSS上传所需的参数，确保参数名称正确
                      ossFormData.append("key", res.data.key);
                      // 确保policy是有效的JSON字符串
                      ossFormData.append("policy", res.data.policy);
                      // 确保参数名称与OSS要求一致
                      ossFormData.append("OSSAccessKeyId", res.data.ossAccessKeyId);
                      ossFormData.append("success_action_status", "200"); // 固定值
                      ossFormData.append("signature", res.data.signature);
                      ossFormData.append("x-oss-security-token", res.data.securityToken);
                      // 文件必须放在最后
                      ossFormData.append("file", file);
                      this.save_loading = true;
                      const xhr = new XMLHttpRequest();
                       xhr.open('POST', res.data.host, true);
                    //  xhr.open('POST', 'http://47.109.99.14:8875/v1/uploadFile', true);
                      // 不设置Content-Type，让浏览器自动设置multipart/form-data和boundary
                      xhr.onload = () => {
                       // console.log(xhr.response,22222222222222222222);
                        if (xhr.status >= 200 && xhr.status < 300) {
                          // 上传成功，设置图片URL
                          const cdnUrl = `https://${res.data.cdnDomain}/${res.data.key}`;
                          //  console.log('CDN URL:', cdnUrl);
                         // const response = JSON.parse(xhr.response);
                          //const cdnUrl = response.data.url;
                          // console.log('上传成功，文件URL:', cdnUrl);
                          this.editForm.logo = cdnUrl;
                          this.save_loading = false;
                          this.$message.success('上传成功');
                        } else {
                          this.save_loading = false;
                          this.$message.error(`上传失败: ${xhr.responseText}`);
                        }
                      };
                      xhr.onerror = (e) => {
                        console.error('上传错误:', e);
                        this.save_loading = false;
                        this.$message.error('上传失败，网络错误');
                      };
                      xhr.send(ossFormData);
                  } else {
                     this.save_loading = false;
                      this.$message({
                        type: 'info',
                        message: res.detail
                      })
                  }
                })
                .catch(err => {
                  this.save_loading = false
                  this.$message.error('操作失败，请稍后再试！')
                })

			},
    //知识库
    kdetail() {
      const datas = {
        page: 1,
        page_size: 100,
        status: 'normal',
      }
      knowledgeList(datas)
        .then(res => {
          console.log(res,'filesssssssssssssssssss')
          if (res.message == "success") {
             this.payTypes = res.data.items;
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
      },
     hexToRgb(hex) {
        // 移除可能存在的 # 符号
        hex = hex.replace(/^#/, '');
        // 处理缩写形式（如 #FFF => FFFFFF）
        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        // 将十六进制分解为RGB分量
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `${r}, ${g}, ${b}`;
      },
    addQuestion() {
      if (this.inputQuestion.trim()) {
        this.recommendQuestions.push(this.inputQuestion.trim());
        this.inputQuestion = ""; // 清空输入框
      }
    },
    deleteQuestion(index) {
      this.recommendQuestions.splice(index, 1);
    },
    handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
    // 获取详情
    getdata(id) {
      chatBOTGet(id)
        .then(res => {
          this.loading = false
          console.log(res,'chatBOTGetchatBOTGetchatBOTGetchatBOTGet')
          if (res.message == "success") {
            //  this.fileList = res.data.files.map(fileInfo => ({
            // 		  name: fileInfo.filename,
            //       id: fileInfo.id,
            // 		  url: fileInfo.url,
            //       parse_status:fileInfo.parse_status,
            // 		}));
      //       editForm: {
      //   // Id: '',
      //   name: '小冰',
      //   icon: '',
      //   logo:'',
      //   theme_color:'#409EFF',
      //   is_chatweb_embed:'0',
      //   chatweb_no:'',
      //   "knowledge": [
      //     {
      //       "id": ''
      //     }
      //   ],
      //   customer_guidance:'off',
      //   welcome_speech:'你好，我是小冰，请问有什么可以帮助你的吗？',
      //   customer_guidance_text:'联系时间：9:00-15:00 周一至周五</br>联系电话：1888888888 </br>联系微信：1234567890',
      // },
          this.editForm.id = id;
          this.editForm.name = res.data.name;
          this.editForm.icon = res.data.icon;
          this.editForm.logo = res.data.logo;
          this.editForm.theme_color = res.data.theme_color;
          this.editForm.knowledge = res.data.knowledge;
          if(res.data.is_chatweb_embed==true){
            this.editForm.is_chatweb_embed = '1';
          }else{
            this.editForm.is_chatweb_embed = '0';
          }
          this.editForm.chatweb_no = res.data.chatweb_no;
          this.editForm.customer_guidance = res.data.customer_guidance;
          this.editForm.welcome_speech = res.data.welcome_speech;
          this.editForm.customer_guidance_text = res.data.customer_guidance_text;
           this.recommendQuestions = res.data.recommended_question;
           console.log(this.editForm,'editForm11111111111111111111111')
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑chatAPI'
        this.editForm.Id = row.deptId
        this.editForm.Name = row.deptName
        this.editForm.platform = row.deptNo
        this.editForm.type = row.deptNo
        this.editForm.k_id = row.deptNo
        this.editForm.is_network = '0'
        this.editForm.is_upload = '0'
      } else {
        this.title = '新增'
        this.editForm.Id = ''
        this.editForm.Name = ''
        this.editForm.platform = ''
        this.editForm.type = ''
        this.editForm.k_id = ''
        this.editForm.is_network = '0'
        this.editForm.is_upload = '0'
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      console.log(editData,22222222222)
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.is_chatweb_embed=='1'){
              this.editForm.is_chatweb_embed = true;
            }else{
              this.editForm.is_chatweb_embed = false;
            }
            this.editForm.recommended_question = this.recommendQuestions
            console.log(this.editForm,'编辑信息')
            // if(this.editForm.knowledge[0]&&this.editForm.knowledge[0].id){
            //   this.editForm.knowledge.id = this.editForm.knowledge[0].id
            //   delete this.editForm.knowledge[0]
            // }
            // console.log(this.editForm,'编辑信息')
          if(this.title=='新增'){
            chatBOTCreate(JSON.stringify(this.editForm))
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.message == "success") {
                this.$message({
                  type: 'success',
                  message: '新增成功！'
                })
                setTimeout(() => {
                this.$router.push({ path: '/chat/bot' })
              }, 1500)
              } else {
                this.$message({
                  type: 'info',
                  message: res.detail
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('失败，请稍后再试！')
            })
          }else{
            console.log(this.editForm,9999999999)
            chatBOTSave(JSON.stringify(this.editForm))
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.message == "success") {
                // this.getdata(this.editForm.id)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
                setTimeout(() => {
                this.$router.push({ path: '/chat/bot' })
              }, 1500)
              } else {
                this.$message({
                  type: 'info',
                  message: res.detail
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }

        } else {
          return false
        }
      })
    },
    // 下线用户
    offlineUser(index, row) {
      this.$confirm('确定要让' + row.userName + '用户下线吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userExpireToken(row.userName)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '用户' + row.userName + '强制下线成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('用户下线失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
 .tips{
  font-size: 12px;
    color: #606266;
    margin-top: 7px;
    margin-left: 140px;
 }

 recommend-container {
  width: 400px;
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.tags-container {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.question-tag {
  margin-right: 10px;
  background: var(--user-bubble-color, #409EFF);
  color: #ffffff;
}
/deep/ .el-tag .el-tag__close{
  color: #ffffff;
}
.input-container {
  display: flex;
  gap: 10px;
}

.question-input {
  flex: 1;
}

.add-btn {
  width: 80px;
}
/* h5 */
.chat-container {
  width: 60%;
  height: 900px;
  display: flex;
  flex-direction: column;
  margin-left: 20%;
  border: 1px solid #eeeeee;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 0 16px;
}
.logo{
  display: flex;
  align-items: center;
}
.logo .name {
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}

.logo .platform {
  margin-left: 8px;
  color: #666;
}

.sub-title {
  color: #999;
}

.message-list {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f5f5f5;
}

.message-item {
  margin: 12px 0;
  display: flex;
}

.message-item.bot {
  justify-content: flex-start;
}

.message-item.user {
  justify-content: flex-end;
}

.message-bubble {
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 18px;
  background: #fff;
  word-break: break-word;
}

.message-item.user .message-bubble {
  background: var(--user-bubble-color, #409EFF);
  color: white;
}

.footer {
  border-top: 1px solid #eee;
  padding: 16px;
  height: 70px !important;
}

.quick-actions {
  display: flex;
  gap: 8px;
  padding: 20px 10px;
}

.input-area {
  display: flex;
  gap: 8px;
}

.input-box {
  flex: 1;
}

.send-btn {
  width: 80px;
  color: #ffffff !important;
  background-color: var(--user-bubble-color, #409EFF) !important;
}
.chat_sz {
  /* position: fixed !important;
  right: 30px !important;
  top: 360px !important;
  z-index: 9999 !important; */
  margin-left: 100px;
}

.sz_btn {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: #ffffff;
  color: #3D3D3D;
  font-size: 12px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 2px 12px rgba(0,0,0,0.15) !important;
  /* transition: all 0.3s ease; */
}

.botimg{
  width: 44px;
  height: 44px;
}

.sz_btn:hover {
  background-color: #f5f5f5;
}

.chatsz_header {
  padding: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chatsz_avatar{
  display: flex;
  align-items: center;
font-weight: 500;
font-size: 18px;
color: #3D3D3D;
}
.avatarimg{
  width: 38px;
  height: 38px;
  border-radius: 100%;
  margin-right: 8px;
  float: left;
}

.sz_logo{
  width: 80px;
  height: 80px;
  text-align: center;
}
.chatsz_logo{
  display: flex;
  justify-content: center;
}
.chatsz_window {
  width: 498px;
  height: 864px;
  background: linear-gradient( 180deg, #FFFFFF 0%, #FFFFFF 66%);
  box-shadow: 2px 4px 12px 0px rgba(192,199,218,0.5);
  border-radius: 30px 30px 30px 30px;
  display: flex;
  flex-direction: column;
  /* position: fixed;
  top: 30px;
  right: 26px; */
}


.chatsz_welcome{
  width: 452px;
  margin: 0 auto;
  background-color: rgba(var(--chat-bubble-color),0.06) !important;
  border-radius: 18px;
  z-index: 1;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}
.chatsz_welcome_text{
  width: 436px;
  font-weight: 500;
  font-size: 16px;
  color: #3D3D3D;
  padding: 12px 24px;
  background-color: rgba(var(--chat-bubble-color),0.3) !important;
  border-radius: 18px;
  z-index: 9;
}

.chatsz_messages {
  height: 300px !important;
  padding: 24px !important;
  overflow-y: auto !important;
  flex-grow: 1;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.chatsz_messages::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.chatsz_actions{
  display: flex;
  flex-direction: column;
  margin-top: 22px;
}
.chatsz_questions{
  max-width: 172px;
    min-height: 34px;
    display: flex;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid rgba(var(--chat-bubble-color), 0.6) !important;
    margin-bottom: 12px;
    align-items: center;
    padding: 0 20px;
    cursor: pointer;
}

.sz_bubble {
  max-width: 400px !important;
  padding: 17px 18px !important;
  background-color: #f0f0f0 !important;
  word-break: break-word;
}
.sz_user{
  width: 100%;
  margin-bottom: 18px;
  display: flex;
}
.sz_user .sz_bubble {
  background-color: rgba(var(--chat-bubble-color),1) !important;
  color: white !important;
  margin-left: auto;
  float:right;
  border-radius: 10px 0px 10px 10px;
}
.szbot{
  display: flex;
  width: 100%;
  margin-bottom: 18px;
}
.szbot .sz_bubble {
  border-radius: 0px 10px 10px 10px;
  margin-top: 14px;
  margin-left: 6px;
}
.chatsz_contact{
  width: 266px;
  padding: 18px;
  background-color: rgba(var(--chat-bubble-color),0.2) !important;
  border-radius: 10px 10px 10px 10px;
  margin-left: 24px;
  margin-bottom: 30px;
}
.input-area {
  display: flex;
  align-items: center;
  margin: 0 24px 28px 24px;
  justify-content: space-between;
}

.custom-input {
  display: flex;
  align-items: center;
  width: 330px;
  height: 56px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(192,199,218,0.5);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #EAECEE;
  padding: 0 18px;
}

.message-input {
  flex-grow: 1;
  padding: 10px;
  border: none !important;
  border-radius: 4px;
  outline: none;
  font-size: 14px;
}
.sz_svg{
  width: 34px;
  height: 34px;
  background-color: #bdbec1; /* 通过这个颜色控制图标颜色 */
  -webkit-mask-image: url(../../assets/img/send.svg);
  mask-image: url(../../assets/img/send.svg);
  cursor: pointer;
}
.sz_svg_send{
  width: 34px;
  height: 34px;
  background-color: rgba(var(--chat-bubble-color),1) !important;
  -webkit-mask-image: url(../../assets/img/send.svg);
  mask-image: url(../../assets/img/send.svg);
  cursor: pointer;
}
.sz_close {
  width: 34px;
  height: 34px;
  background-color: rgba(var(--chat-bubble-color),1) !important;
  -webkit-mask-image: url(../../assets/img/close.svg);
  mask-image: url(../../assets/img/close.svg);
  cursor: pointer;
}
.sz_rgkf{
  width: 62px;
  height: 62px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(192,199,218,0.5);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #EAECEE;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sz_svg_rgkf{
  width: 34px;
  height: 34px;
  background-color: rgba(var(--chat-bubble-color),1) !important;
  -webkit-mask-image: url(../../assets/img/rgkf.svg);
  mask-image: url(../../assets/img/rgkf.svg);
  cursor: pointer;
}

.message-input:focus {
  border-color: #409eff;
}

</style>





// WEBPACK FOOTER //
// src/views/chat/bot_add.vue